import { Navigate } from 'react-router-dom';
import { isAuthenticated, getStoredUser, hasAnyPermission } from '../services/authService';

/**
 * 인증 및 권한이 필요한 라우트를 보호하는 컴포넌트
 * - 로그인하지 않은 사용자는 로그인 페이지로 리다이렉트
 * - 권한이 없는 사용자는 홈으로 리다이렉트
 *
 * @param {React.ReactNode} children - 렌더링할 자식 컴포넌트
 * @param {string[]} allowedRoles - 허용된 역할 목록 (예: ['ADMIN', 'SUPER_ADMIN'])
 * @param {string[]} requiredPermissions - 필요한 권한 목록 (예: ['system.view'])
 */
const PrivateRoute = ({ children, allowedRoles, requiredPermissions }) => {
    const isAuth = isAuthenticated();

    if (!isAuth) {
        return <Navigate to="/login" replace />;
    }

    const user = getStoredUser();

    // 역할 기반 접근 제어
    if (allowedRoles && allowedRoles.length > 0) {
        const userRole = user?.role;
        // SUPER_ADMIN은 모든 접근 허용
        if (userRole !== 'SUPER_ADMIN' && !allowedRoles.includes(userRole)) {
            return <Navigate to="/home" replace />;
        }
    }

    // 권한 기반 접근 제어
    if (requiredPermissions && requiredPermissions.length > 0) {
        if (!hasAnyPermission(requiredPermissions)) {
            return <Navigate to="/home" replace />;
        }
    }

    return children;
};

export default PrivateRoute;
